import { ArrowLeft, Compass } from 'lucide-react'
import { Link } from 'react-router-dom'
import '../stocks.css'
export function NotFoundPage() { return <main className="not-found"><div className="not-found-mark"><Compass size={24} aria-hidden="true" /></div><p className="not-found-code">404</p><h1>这个页面不存在</h1><p>地址可能已经失效，返回股票查询继续查找。</p><Link className="button button-primary" to="/stocks"><ArrowLeft size={17} aria-hidden="true" />返回股票查询</Link></main> }

